import React from "react";
import Svg, { Path } from "react-native-svg";

export default function BarChartSwitchViewIcon(props) {
  return props.showLineChart ? (
    <Svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8892 2H14.1114C14.4181 2 14.667 2.3584 14.667 2.8V13.2C14.667 13.6416 14.4181 14 14.1114 14H11.8892C11.5825 14 11.3337 13.6416 11.3337 13.2V2.8C11.3337 2.3584 11.5825 2 11.8892 2ZM8.7781 5.33333H6.55588C6.24921 5.33333 6.00033 5.6863 6.00033 6.12121V13.2121C6.00033 13.647 6.24921 14 6.55588 14H8.7781C9.08477 14 9.33366 13.647 9.33366 13.2121V6.12121C9.33366 5.6863 9.08477 5.33333 8.7781 5.33333ZM3.44477 8H1.22255C0.915881 8 0.666992 8.384 0.666992 8.85714V13.1429C0.666992 13.616 0.915881 14 1.22255 14H3.44477C3.75144 14 4.00033 13.616 4.00033 13.1429V8.85714C4.00033 8.384 3.75144 8 3.44477 8Z"
        fill={props.fill || "#2D3142"}
      />
    </Svg>
  ) : (
    <Svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.32644 3.79889L3.73958 6.44366H0C0.145619 4.68727 0.946198 3.0498 2.24288 1.85617C3.53956 0.662547 5.23758 0 7 0C8.76242 0 10.4604 0.662547 11.7571 1.85617C13.0538 3.0498 13.8544 4.68727 14 6.44366H9.92887C9.82779 6.44368 9.72844 6.46985 9.64047 6.51964C9.5525 6.56942 9.47892 6.64112 9.42686 6.72776L8.27699 8.64441L6.37264 3.88324C6.33217 3.78191 6.26421 3.69389 6.17641 3.62911C6.08861 3.56432 5.98446 3.52535 5.8757 3.51658C5.76694 3.50781 5.65789 3.5296 5.56085 3.57948C5.4638 3.62936 5.38262 3.70535 5.32644 3.79889ZM8.67356 10.26L10.2604 7.61521H14C13.8544 9.37161 13.0538 11.0091 11.7571 12.2027C10.4604 13.3963 8.76242 14.0589 7 14.0589C5.23758 14.0589 3.53956 13.3963 2.24288 12.2027C0.946198 11.0091 0.145619 9.37161 0 7.61521H4.07113C4.17221 7.61519 4.27156 7.58902 4.35953 7.53924C4.44749 7.48945 4.52108 7.41775 4.57314 7.33111L5.72301 5.41446L7.62736 10.1774C7.66785 10.2788 7.73587 10.3668 7.82374 10.4316C7.91162 10.4964 8.01585 10.5354 8.12469 10.5441H8.17155C8.27262 10.5441 8.37198 10.5179 8.45994 10.4681C8.54791 10.4183 8.6215 10.3466 8.67356 10.26Z"
        fill={props.fill || "#2D3142"}
      />
    </Svg>
  );
}
